import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { QRCode } from 'react-qrcode-logo'; // Import QR Code generator
import logo from '../assets/logo.png'; // Logo for QR Code
import logo2 from '../assets/logo2.png';
import './CSS/Login.css';

class ShowTokens3 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      token: null,
      copySuccess: '',
      qrCodeUrl: '', // Stores the image version of the QR code
    };
  }

  componentDidMount() {
    const token = localStorage.getItem('token');
    if (token) {
      this.setState({ token }, this.generateQRCode);
    }
  }

  copyToClipboard = () => {
    if (this.state.token) {
      navigator.clipboard.writeText(this.state.token);
      this.setState({ copySuccess: 'Token copied to clipboard!' });

      // Auto-hide message after 3 seconds
      setTimeout(() => this.setState({ copySuccess: '' }), 3000);
    }
  };

  generateQRCode = () => {
    if (!this.state.token) return;

    setTimeout(() => {
      const canvas = document.querySelector('#qrCodeCanvas canvas');
      if (canvas) {
        const qrDataUrl = canvas.toDataURL('image/png'); // Convert canvas to image URL
        this.setState({ qrCodeUrl: qrDataUrl });
      }
    }, 1000); // Delay to ensure QR code is rendered before capturing it
  };

  downloadQRCode = () => {
    if (!this.state.qrCodeUrl) return;

    const downloadLink = document.createElement('a');
    downloadLink.href = this.state.qrCodeUrl;
    downloadLink.download = 'token_qr_code.png';
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };

  render() {
    const { token, copySuccess, qrCodeUrl } = this.state;

    return (
      <div className="token-container d-flex align-items-center justify-content-center">
        <div className="text-center">
          <img className="logo" src={logo} alt="Logo" />
          <h2>Your Generated Token</h2>
          <div className="row justify-content-center">
            <div className="col-sm-8">
              <div className="card">
                <div className="card-body">
                  {token ? (
                    <>
                      <textarea
                        id="tokenTextarea"
                        rows="8"
                        cols="50"
                        className="form-control"
                        value={token}
                        readOnly
                      />
                      <button onClick={this.copyToClipboard} className="btn btn-dark mt-3">
                        Copy Token
                      </button>
                      {copySuccess && <div className="alert alert-success mt-3">{copySuccess}</div>}

                      {/* QR Code Display */}
                      <div className="mt-4">
                        <h4>Token QR Code</h4>

                        {/* Generate the QR Code but keep it hidden */}
                        <div id="qrCodeCanvas" style={{ display: 'none' }}>
                          <QRCode
                            value={token}
                            size={250}
                            logoImage={logo}
                            logoWidth={50}
                            logoHeight={50}
                            qrStyle="dots"
                            eyeRadius={10}
                          />
                        </div>

                        {/* Show QR Code as Image for Long-Press Save */}
                        {qrCodeUrl && (
                          <a href={qrCodeUrl} download="token_qr_code.png">
                            <img src={qrCodeUrl} alt="QR Code" className="qr-image mt-2" style={{ width: '250px' }} />
                          </a>
                        )}
                        <p className="small">Long-press the QR code to save on mobile</p>

                        {/* Download Button for Desktop Users */}
                        <button onClick={this.downloadQRCode} className="btn btn-success mt-3">
                          Download QR Code
                        </button>
                      </div>
                    </>
                  ) : (
                    <p>No token available. Please log in or register.</p>
                  )}
                  <div>Powered by</div>
                  <img className="logo2" src={logo2} alt="Logo 2" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(ShowTokens3);
